"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Layout_1 = require("../core/base/Layout");
class Layout extends Layout_1.Layout {
    loadStyle() {
        return require(`../theme/main.scss`);
    }
}
exports.default = Layout;



// WEBPACK FOOTER //
// ./src/layouts/layout.tsx